import styles from './QuoteTermsRowItem.module.css';

function QuoteTermsRowItem({ children }) {
  return <li className={styles.item}>{children}</li>;
}

export default QuoteTermsRowItem;
